import { SvgComponent } from './SvgComponent';
import { IconProps } from './types';

const CheckIcon = ({ width = 14, height = 8, color = '#2BB45D', ...props }: IconProps) => (
  <SvgComponent width={width}
    height={height}
    viewBox='0 0 14 8'
    {...props}
  >
    <path
      fill={color}
      d='M13.77.228 6.073 7.855a.501.501 0 0 1-.751-.052.489.489 0 0 1-.053-.045L.23 2.764a.133.133 0 0 1 .094-.228h1.03c.035 0 .069.014.094.039L5.72 6.808l6.832-6.77A.133.133 0 0 1 12.646 0h1.03a.133.133 0 0 1 .094.228Z'
    />
  </SvgComponent>
);
export default CheckIcon;
